import addHours from 'date-fns/addHours';
import addMinutes from 'date-fns/addMinutes';
import format from 'date-fns/format';
import parse from 'date-fns/parse';

export function getTimeDifference(
  fromOffset: string,
  toOffset: string,
): { hoursDifference: number; minutesDifference: number } {
  const [fromHoursOffset, fromMinutesOffset] = fromOffset.split(':');
  const [toHoursOffset, toMinutesOffset] = toOffset.split(':');

  const hoursDifference: number =
    parseInt(toHoursOffset, 10) - parseInt(fromHoursOffset, 10);
  const minutesDifference: number =
    parseInt(toMinutesOffset, 10) - parseInt(fromMinutesOffset, 10);
  return { hoursDifference, minutesDifference };
}

export function convertTime(
  time: string,
  fromOffset: string,
  toOffset: string,
): string {
  const { hoursDifference, minutesDifference } = getTimeDifference(
    fromOffset,
    toOffset,
  );

  const [hours, minutes] = time.split(':');

  const originalDateTime = parse(
    '1970-01-01T00:00',
    "yyyy-MM-dd'T'HH:mm",
    new Date(),
  );
  const newTime = addMinutes(
    addHours(
      addMinutes(
        addHours(originalDateTime, parseInt(hours, 10)),
        parseInt(minutes, 10),
      ),
      hoursDifference,
    ),
    minutesDifference,
  );

  return format(newTime, 'HH:mm');
}
